/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
import { runQuery } from './GraphQLWSClient';
import * as Mutation from './mutations';

export const rename = async (appId, name) => {
	const result = await runQuery(Mutation.renameApp, { appId, name });
	return result.renameMachine.success || result.renameMachine.code;
};
export const updateDescription = async (appId, description) => {
	const result = await runQuery(Mutation.updateAppDescription, { appId, description });
	return result.updateMachineDescription.success || result.updateMachineDescription.code;
};
export const deleteApp = async (appId) => {
	const result = await runQuery(Mutation.deleteApp, { appId });
	return result.deleteMachine.success || result.deleteMachine.code;
};
export const createApp = async (scope, name) => {
	const result = await runQuery(Mutation.createApp, { scope, name });
	if (result.createApp.success) {
		return result.createApp.app.id;
	}
	throw new Error(result.createApp.code);
};
export const duplicateApp = async (appId) => {
	const result = await runQuery(Mutation.duplicateApp, { appId });
	if (result.duplicateMachine.success) {
		return result.duplicateMachine.id;
	}
	throw new Error(result.duplicateMachine.code);
};
export const addToFavorites = async (appId) => {
	const result = await runQuery(Mutation.addAppToFavorites, { appId });
	if (result.userAddFavorite.success) {
		return result.userAddFavorite.success;
	}
	throw new Error(result.userAddFavorite.code);
};

export const removeFromFavorites = async (appId) => {
	const result = await runQuery(Mutation.removeAppFromFavorites, { appId });
	if (result.userRemoveFavorite.success) {
		return result.userRemoveFavorite.id;
	}
	throw new Error(result.userRemoveFavorite.code);
};
